import { ACHIEVEMENT_API_PATHS } from '../constants/api'
import { apiRequest } from './client'
import type { ApiAchievement } from './types'

export function listAchievements(activeOnly = true): Promise<ApiAchievement[]> {
  return apiRequest<ApiAchievement[]>(ACHIEVEMENT_API_PATHS.root, {
    query: { activeOnly },
  })
}
